<div>
    <label for="assessment-form" class="form-label fw-bold" i18n>
        Assessment form:
    </label>
    <select
        id="assessment-form"
        class="form-select"
        [formControl]="control()"
    >
        <option [ngValue]="" disabled i18n>
            Select an assessment form
        </option>
        @for (assessmentOption of options(); track assessmentOption.id) {
        <option [ngValue]="assessmentOption.id">
            {{ assessmentOption.name }}
        </option>
        } @empty {
        <option [ngValue]="null" disabled i18n>No assessment forms available</option>
        }
    </select>
</div>
